<template>
  <v-dialog v-model="dialog" scrollable max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="secondary" x-large rounded v-bind="attrs" v-on="on">
        WURD LID!
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <span class="headline">Wurd lid!</span>
      </v-card-title>
      <v-card-text>
        <v-row justify="center" align="center" v-if="loading">
          <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
          ></v-progress-circular>
        </v-row>
        <v-form v-if="!loading && !sent">
          <p>Lit hjirre dyn gegevens achter, en wy nimme kontakt mei dy op!</p>
          <v-text-field label="Wat is dyn namme?*"
                        prepend-icon="mdi-account"
                        :rules="rules"
                        required
                        v-model="name">
          </v-text-field>
          <v-text-field label="Hoe âld bist?*"
                        prepend-icon="mdi-calendar-account"
                        :rules="rules"
                        required
                        v-model="age">
          </v-text-field>
          <v-text-field label="Wat is dyn telefoannûmer?*"
                        prepend-icon="mdi-cellphone-android"
                        :rules="rules"
                        required
                        v-model="phoneNumber">
          </v-text-field>
          <v-text-field label="Wat is dyn e-mail?"
                        prepend-icon="mdi-email"
                        v-model="email">
          </v-text-field>
          <v-select label="Ik kom út/fan"
                    :items="locations"
                    prepend-icon="mdi-home-variant"
                    v-model="location">
          </v-select>
          <v-radio-group label="Ik bin (oankommend) studint*"
                         prepend-icon="mdi-briefcase"
                         required
                         v-model="isStudent">
            <v-radio :value="true" label="Ja"></v-radio>
            <v-radio :value="false" label="Nee"></v-radio>
          </v-radio-group>
          <v-text-field label="Hokker stúdzje dochst of silst dwaan?*"
                        prepend-icon="mdi-book-open-page-variant"
                        v-if="isStudent"
                        v-model="education"
                        :rules="rules"
                        required>
          </v-text-field>
          <v-textarea label="Wêrom wolst dochs lid wurde?*"
                      prepend-icon="mdi-comment-question"
                      v-if="!isStudent"
                      v-model="reason"
                      :rules="rules"
                      required
                      rows="2"
                      dense>
          </v-textarea>
          <v-textarea label="Wolst noch wat kwyt?"
                      prepend-icon="mdi-message"
                      v-model="extra"
                      rows="3"
                      dense>
          </v-textarea>
          <small>*dizze moast ynfolle</small>
        </v-form>
        <v-container v-if="sent">
          Bedankt foar dyn ynteresse {{ name }}! Wy sille gau kontakt mei dy opnimme.
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click.stop="dialog=false">Slúte</v-btn>
        <v-btn color="primary" :disabled="!formIsValid || loading || sent" @click="submit()">Ferstjoer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      name: '',
      age: null,
      phoneNumber: '',
      email: '',
      location: '',
      isStudent: true,
      education: '',
      reason: '',
      extra: '',
      locations: ['Greidhoeke', 'De Klei', 'De Wâlden', 'Gaasterlân', 'Stellingwerven', 'De eilannen', 'Oars'],
      rules: [val => !!val || 'Dizze moast ynfolle'],
      loading: false,
      sent: false
    }),

    computed: {
      formIsValid() {
        return this.name && this.age && this.phoneNumber && (this.isStudent && this.education || !this.isStudent && this.reason)
      }
    },

    methods: {
      submit: function () {
        this.loading = true;
        this.axios.post('https://api.wurdlid.bernlef.frl/ynskriuwe', {
          name: this.name,
          age: this.age,
          email: this.email,
          'phone_number': this.phoneNumber,
          location: this.location,
          'is_student': this.isStudent,
          education: this.education,
          reason: this.reason,
          extra: this.extra,
        }).then(() => {
          this.loading = false;
          this.sent = true;
        }).catch(() => {
          this.loading = false;
        })
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
